import { useState, useCallback, useRef } from "react";

const EDGE_URL = `${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/gemini-npc`;

export interface NPCMessage {
  id: number;
  role: "user" | "npc";
  text: string;
}

export function useNPCChat(npcType: string, context?: string) {
  const [messages, setMessages] = useState<NPCMessage[]>([]);
  const [loading, setLoading] = useState(false);
  const idRef = useRef(0);

  const sendMessage = useCallback(
    async (text: string) => {
      if (!text.trim() || loading) return;

      idRef.current += 1;
      const userMsg: NPCMessage = { id: idRef.current, role: "user", text };
      setMessages((prev) => [...prev, userMsg]);
      setLoading(true);

      try {
        const history = messages.map((m) => ({
          role: m.role === "user" ? "user" : "npc",
          text: m.text,
        }));

        const res = await fetch(EDGE_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ npcType, userMessage: text, history, context }),
        });

        const data = await res.json();
        idRef.current += 1;
        const npcMsg: NPCMessage = {
          id: idRef.current,
          role: "npc",
          text: data.reply ?? "잠시 후 다시 시도해주세요.",
        };
        setMessages((prev) => [...prev, npcMsg]);
      } catch {
        idRef.current += 1;
        setMessages((prev) => [
          ...prev,
          { id: idRef.current, role: "npc", text: "연결에 문제가 생겼어요. 잠시 후 다시 시도해주세요." },
        ]);
      } finally {
        setLoading(false);
      }
    },
    [npcType, context, messages, loading]
  );

  const clear = useCallback(() => setMessages([]), []);

  return { messages, loading, sendMessage, clear };
}
